import React from 'react';
import PropTypes from 'prop-types';

const Reason = ({ image, title, text }) => (
  <div className="reason">
    <img src={image} alt="" />
    <h5>{title}</h5>
    <p>{text}</p>
  </div>
);

Reason.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};
export default Reason;



// WEBPACK FOOTER //
// ./src/components/Reason.js